import { Modal, ModalProps } from "antd";
import styles from "./RootModal.module.scss";

export interface RootModalProps extends ModalProps {
  wrapperClassName?: string;
}

export default function RootModal(props: RootModalProps) {
  return (
    <Modal
      rootClassName={styles.RootModal}
      width={1000}
      zIndex={5}
      {...props}
    >
      <div className={`${styles.wrapper} ${props.wrapperClassName}`}>{props.children}</div>
    </Modal>
  );
}
